import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const ShinseiShubetsu = props => {
  return <Dropdown.Static kubunKey='shinsei_shubetsu' {...props} />
}
